export const IS_RUNNING_IN_CYPRESS = Boolean(
  typeof window !== 'undefined' &&
    (window as Window & typeof globalThis & { Cypress: unknown }).Cypress,
);
